import { configureStore } from "@reduxjs/toolkit";
import { injectStore } from "../api";
import authSlice from "./slices/auth/slice";
import cartSlice from "./slices/cart/slice";
import coursesSlice from "./slices/courses/slice";
import ordersSlice from "./slices/orders/slice";
import adminSlice from "./slices/admin/slice";
import certificatesSlice from "./slices/certificates/slice";
import lessonProgressSlice from "./slices/lessonProgress/slice";
import promoEmailsSlice from "./slices/promoEmails/slice";

const store = configureStore({
  reducer: {
    authInfo: authSlice,
    cart: cartSlice,
    courses: coursesSlice,
    orders: ordersSlice,
    admin: adminSlice,
    certificates: certificatesSlice,
    lessonProgress: lessonProgressSlice,
    promoEmails: promoEmailsSlice,
  },

  devTools: false,
});

injectStore(store);

export default store;
